import React, { FC } from 'react';
import { ACTIONS_MENU_WIDTH } from '@components/ActionsMenu/constants';
import { Popover, PopoverProps } from '@mui/material';
import { bindPopover } from 'material-ui-popup-state/hooks';

export type BasePopoverProps = ReturnType<typeof bindPopover> &
  PopoverProps & {
    width?: number;
    mt?: number;
  };

const BasePopover: FC<BasePopoverProps> = ({
  children,
  width = ACTIONS_MENU_WIDTH,
  anchorReference = 'anchorEl',
  mt = 3,
  ...props
}) => {
  return (
    <Popover
      anchorReference={anchorReference}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      slotProps={{ paper: { sx: { width, mt } } }}
      {...props}
    >
      {children}
    </Popover>
  );
};

export default BasePopover;
